// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-9852072a]{padding-top:51px}.title[data-v-9852072a]{font-size:22px;line-height:30px;font-family:SFProDisplay-Medium,sans-serif;margin-bottom:32px;margin-top:0}.mb-48[data-v-9852072a]{margin-bottom:48px}.error-msg[data-v-9852072a]{color:#da6556}", ""]);
// Exports
module.exports = exports;
